module.exports = __webpack_public_path__ + "static/media/enagic-logo.9994265a.svg";